// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-image[data-v-630b4252]{max-height:20rem}.section[data-v-630b4252]{max-width:1200px;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
